import { FieldModel, UserId } from '@cibo/core'
import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { createContext, useContext } from 'react'

export interface FieldSelectionContextState {
  selectedFields: FieldModel[]
  selectionModel: GridRowSelectionModel
  setSelectionModel: (model: GridRowSelectionModel) => void
  selectedRowIds: GridRowId[]
  deselectRowIds(ids: GridRowId[]): void
  clearSelectionModel(): void
  selectionOwnedByUsers: UserId[]
}

export const FieldSelectionContext = createContext<FieldSelectionContextState>({
  selectedFields: [],
  setSelectionModel: console.log,
  selectionModel: { type: 'include', ids: new Set() },
  selectedRowIds: [],
  deselectRowIds: console.log,
  clearSelectionModel: console.log,
  selectionOwnedByUsers: [],
})
FieldSelectionContext.displayName = 'FieldSelectionContext'

export const useFieldSelectionContext = () => useContext(FieldSelectionContext)
